export default "__VITE_ASSET__BczYoN$h__"